//@ts-check
import {Text} from '@/components-v2/atoms/Text/Text'
import {LabelValue} from '@/components-v2/molecules'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {ProductComboSteps} from '@/types/productComboTypes'
import {ComboReviewSection} from './ComboReviewSection'

export const ComboReviewDisplay = () => {
  const {
    productCombo: {imageUrl, comboSubtitle, comboDetails, comboDetails2, comboDescription, keywords, productLimit},
  } = useProductCombo()
  const languagesFromHook = useFeatureFlagLanguages()
  const languages = languagesFromHook

  return (
    <ComboReviewSection
      label="Display"
      step={ProductComboSteps.DISPLAY}
      content={
        <div className="flex w-full flex-col gap-6 overflow-hidden">
          <div>
            <div className="grid grid-cols-1 items-center gap-x-4 py-6 md:grid-cols-3">
              <div>
                <img src={imageUrl} alt="Product Combo" className="h-auto w-full max-w-40 rounded" />
              </div>
              <LabelValue keyName="Product Limit" val={productLimit} />
            </div>
          </div>
          <div>
            <div className="h-px bg-[var(--secondary-800)]" />
            <div className="grid grid-cols-1 divide-y divide-[var(--secondary-800)]">
              {languages.map(({code, language}) => (
                <div key={code} className="py-6">
                  <Text size="small" variant="bold">
                    <span className="font-normal">Language: </span>
                    {language}
                  </Text>
                  <div className="grid grid-cols-1 items-center gap-x-4 md:grid-cols-3">
                    <LabelValue keyName="Combo Subtitle" val={comboSubtitle?.[code] || '-'} />
                    <LabelValue keyName="Combo Details" val={comboDetails?.[code] || '-'} />
                    <LabelValue keyName="Combo Details 2" val={comboDetails2?.[code] || '-'} />
                    <LabelValue keyName="Description" val={comboDescription?.[code] || '-'} />
                    <LabelValue keyName="Keywords" val={keywords?.[code] || '-'} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    />
  )
}
